import once from '../dom/once';

const updateMedia = (videoElement, media) => new Promise((resolve) => {
  const state = {
    currentTime: videoElement.currentTime,
    playing: !videoElement.paused
  };

  if (state.playing) {
    videoElement.pause();
  }

  videoElement.src = media.src;
  // const source = document.createElement('source');
  // source.setAttribute('src', media.src);
  // videoElement.appendChild(source);
  videoElement.load();

  once(videoElement, 'loadeddata', () => {
    videoElement.currentTime = state.currentTime;

    if (state.playing) {
      videoElement.play();
    }

    resolve();
  });
});

export default updateMedia;
